var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.modelBase,
      title: _vm.title,
      icon: _vm.icon,
      color: "primary white--text",
      show: _vm.dialog,
      maxWidth: "98%",
      actions: false,
    },
    on: {
      "update:model": function ($event) {
        _vm.modelBase = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "tools",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "main-container",
              {
                attrs: {
                  showToolBar: false,
                  icon: "mdi-account-cash",
                  title: "Cartão de Ponto",
                },
              },
              [
                _c(
                  "v-overlay",
                  { attrs: { value: _vm.generatingSheets, absolute: "" } },
                  [
                    _c("v-progress-circular", {
                      attrs: {
                        indeterminate: "",
                        size: "64",
                        color: "primary",
                      },
                    }),
                    _c("p", { staticClass: "mt-4 white--text" }, [
                      _vm._v(_vm._s(_vm.generatingMessage)),
                    ]),
                    _c("p", { staticClass: "text-caption white--text" }, [
                      _vm._v("Aguarde a atualização para continuar."),
                    ]),
                  ],
                  1
                ),
                _vm.timeSheetDisabledName
                  ? _c(
                      "v-alert",
                      {
                        staticClass: "mb-4",
                        attrs: {
                          type: "warning",
                          outlined: "",
                          dense: "",
                          icon: "mdi-alert-outline",
                        },
                      },
                      [
                        _vm._v(
                          ' O período "' +
                            _vm._s(_vm.timeSheetDisabledName) +
                            '" não está habilitado para folha de ponto. '
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.collections.length === 0 && !_vm.loading && !_vm.workTimeId
                  ? _c(
                      "v-alert",
                      {
                        staticClass: "mb-4",
                        attrs: {
                          type: "info",
                          outlined: "",
                          dense: "",
                          icon: "mdi-information-outline",
                        },
                      },
                      [
                        _vm._v(
                          " Suas folhas de ponto serão exibidas aqui conforme forem geradas. Selecione um período para visualizar. "
                        ),
                      ]
                    )
                  : _vm.collections.length === 0 &&
                    !_vm.loading &&
                    _vm.workTimeId
                  ? _c(
                      "v-alert",
                      {
                        staticClass: "mb-4",
                        attrs: {
                          type: "info",
                          outlined: "",
                          dense: "",
                          icon: "mdi-information-outline",
                        },
                      },
                      [
                        _vm._v(
                          " Nenhuma folha de ponto encontrada para o período selecionado. "
                        ),
                      ]
                    )
                  : _vm._e(),
                _c("emc-table-items", {
                  attrs: {
                    headers: _vm.headers,
                    params: _vm.params,
                    collections: _vm.collections,
                    meta: _vm.meta,
                    itemDelete: _vm.itemDelete,
                    itemEdit: _vm.modelItem,
                    loading: _vm.loading,
                    find: false,
                    showDelete: _vm.showDeleteButton,
                    hideEdit: _vm.hideEdit,
                  },
                  on: {
                    "update:params": function ($event) {
                      _vm.params = $event
                    },
                    "update:collections": function ($event) {
                      _vm.collections = $event
                    },
                    "update:meta": function ($event) {
                      _vm.meta = $event
                    },
                    "update:itemDelete": function ($event) {
                      _vm.itemDelete = $event
                    },
                    "update:item-delete": function ($event) {
                      _vm.itemDelete = $event
                    },
                    "update:itemEdit": function ($event) {
                      _vm.modelItem = $event
                    },
                    "update:item-edit": function ($event) {
                      _vm.modelItem = $event
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.month",
                      fn: function ({ item }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "text-center" },
                            [
                              _c(
                                "v-chip",
                                {
                                  attrs: {
                                    "x-small": "",
                                    color: "primary",
                                    outlined: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(item.month) + "/" + _vm._s(item.year)
                                  ),
                                ]
                              ),
                              _c("br"),
                              _c("small", { staticClass: "grey--text" }, [
                                _vm._v("ID: " + _vm._s(item.id)),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.company",
                      fn: function ({ item }) {
                        return [
                          item.company
                            ? _c("span", [_vm._v(_vm._s(item.company.name))])
                            : _vm._e(),
                          item.contract
                            ? _c("small", [
                                _c("br"),
                                _vm._v(
                                  "Matrícula: " +
                                    _vm._s(item.contract.registration)
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "item.campuses",
                      fn: function ({ item }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                item.campuses.map((o) => o["name"]).join(", ")
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.shifts",
                      fn: function ({ item }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                item.shifts.map((o) => o["name"]).join(", ")
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.status_sign.name",
                      fn: function ({ item }) {
                        return [
                          item.status_sign
                            ? _c(
                                "v-chip",
                                {
                                  attrs: {
                                    "x-small": "",
                                    color: _vm.getStatusColor(item),
                                    outlined: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(item.status_sign.name) + " "
                                  ),
                                ]
                              )
                            : _c("span", [_vm._v("—")]),
                        ]
                      },
                    },
                    {
                      key: "actions",
                      fn: function ({ item }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex align-center actions-row" },
                            [
                              _c("emc-table-icon", {
                                attrs: {
                                  cancelAutoSmall: "",
                                  color: "success",
                                  icon: "mdi-calendar-edit",
                                  "text-button": _vm.showActionText
                                    ? "Editar"
                                    : null,
                                  "tool-tip": _vm.isBlockedByTerms
                                    ? "Assine o(s) termo(s) obrigatório(s) pendentes para liberar a edição"
                                    : "Editar Marcações",
                                  disabled: _vm.isBlockedByTerms,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.getSheetItems(item)
                                  },
                                },
                              }),
                              _c("emc-table-icon-download-pdf", {
                                attrs: {
                                  cancelAutoSmall: "",
                                  toolTip: "Espelho de Ponto",
                                  "text-button": _vm.showActionText
                                    ? "Espelho"
                                    : null,
                                  type: "teacher-extract-time-sheet",
                                  item: item,
                                },
                              }),
                              item.occurrence_sheet_sign_status_id != 3 &&
                              _vm.getSignatureType(item) == "email"
                                ? _c("emc-table-icon", {
                                    attrs: {
                                      disabled:
                                        item.occurrence_sheet_sign_status_id !=
                                          1 || !_vm.isBeforeCurrentMonth(item),
                                      cancelAutoSmall: "",
                                      color: "purple",
                                      icon: "mdi-signature-freehand",
                                      "text-button": _vm.showActionText
                                        ? "Assinar"
                                        : null,
                                      "tool-tip":
                                        "Assinar Espelho de Ponto (envio por e-mail via B4)",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.selectedItem = item
                                        _vm.showQuestionSign = true
                                      },
                                    },
                                  })
                                : item.occurrence_sheet_sign_status_id != 3
                                ? _c("emc-table-icon", {
                                    attrs: {
                                      disabled:
                                        ![1, 2].includes(
                                          item.occurrence_sheet_sign_status_id
                                        ) || !_vm.isBeforeCurrentMonth(item),
                                      cancelAutoSmall: "",
                                      color: "purple darken-2",
                                      icon: "mdi-file-sign",
                                      "text-button": _vm.showActionText
                                        ? "Assinar Aqui"
                                        : null,
                                      "tool-tip":
                                        item.occurrence_sheet_sign_status_id ==
                                        2
                                          ? "Retomar assinatura sem sair do SysClass"
                                          : "Assinar Espelho de Ponto sem sair do SysClass",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openEmbeddedSign(item)
                                      },
                                    },
                                  })
                                : _vm._e(),
                              item.occurrence_sheet_sign_status_id == 3
                                ? _c("emc-table-icon-download-pdf", {
                                    attrs: {
                                      cancelAutoSmall: "",
                                      toolTip:
                                        "Baixar Espelho de Ponto Assinado",
                                      "text-button": _vm.showActionText
                                        ? "Assinado"
                                        : null,
                                      type: "occurrence-sheet-signed",
                                      item: item,
                                      color: "teal darken-2",
                                      icon: "mdi-file-check-outline",
                                    },
                                  })
                                : _vm._e(),
                              _c("emc-table-icon", {
                                attrs: {
                                  cancelAutoSmall: "",
                                  color: "info",
                                  icon: "mdi-history",
                                  "text-button": _vm.showActionText
                                    ? "Histórico"
                                    : null,
                                  "tool-tip": "Ver Histórico de Assinaturas",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openHistoryDialog(item)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("DialogsConfirmation", {
                  attrs: {
                    show: _vm.showQuestionSign,
                    message:
                      "Confirma o  envio do Espelho de Ponto para Assinatura pela plataforma da B4?",
                    loading: _vm.loadingSign,
                    colorTitle: "primary",
                  },
                  on: {
                    "update:show": function ($event) {
                      _vm.showQuestionSign = $event
                    },
                    confirm: function ($event) {
                      return _vm.signDocument()
                    },
                  },
                }),
                _c("sys-occurrence-sign-embedded-dialog", {
                  attrs: { show: _vm.showEmbeddedSign, item: _vm.selectedItem },
                  on: {
                    "update:show": function ($event) {
                      _vm.showEmbeddedSign = $event
                    },
                    onCompleted: function ($event) {
                      return _vm.getData()
                    },
                  },
                }),
                _c(
                  "v-dialog",
                  {
                    attrs: { "max-width": "600", persistent: "" },
                    model: {
                      value: _vm.showCancelDialog,
                      callback: function ($$v) {
                        _vm.showCancelDialog = $$v
                      },
                      expression: "showCancelDialog",
                    },
                  },
                  [
                    _c(
                      "v-card",
                      [
                        _c(
                          "v-card-title",
                          { staticClass: "error white--text" },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "mr-2", attrs: { dark: "" } },
                              [_vm._v("mdi-cancel")]
                            ),
                            _vm._v(" Cancelar Assinatura "),
                          ],
                          1
                        ),
                        _c(
                          "v-card-text",
                          { staticClass: "pt-4" },
                          [
                            _c(
                              "v-alert",
                              {
                                staticClass: "mb-4",
                                attrs: {
                                  type: "warning",
                                  dense: "",
                                  outlined: "",
                                },
                              },
                              [
                                _vm._v(
                                  " Atenção: O cancelamento da assinatura permitirá que o docente assine novamente. O documento anterior será mantido no histórico para auditoria. "
                                ),
                              ]
                            ),
                            _c("v-textarea", {
                              ref: "cancelReasonField",
                              attrs: {
                                label: "Justificativa *",
                                placeholder:
                                  "Informe o motivo do cancelamento (mínimo 10 caracteres)",
                                rules: [
                                  (v) => !!v || "Justificativa obrigatória",
                                  (v) =>
                                    (v && v.length >= 10) ||
                                    "Mínimo 10 caracteres",
                                ],
                                outlined: "",
                                counter: "",
                                maxlength: 1000,
                                rows: "4",
                              },
                              model: {
                                value: _vm.cancelReason,
                                callback: function ($$v) {
                                  _vm.cancelReason = $$v
                                },
                                expression: "cancelReason",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-card-actions",
                          [
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { text: "" },
                                on: { click: _vm.closeCancelDialog },
                              },
                              [_vm._v("Voltar")]
                            ),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "error",
                                  loading: _vm.loadingCancel,
                                  disabled:
                                    !_vm.cancelReason ||
                                    _vm.cancelReason.length < 10,
                                },
                                on: { click: _vm.confirmCancelSignature },
                              },
                              [_vm._v(" Confirmar Cancelamento ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("sys-occurrence-signature-history-dialog", {
                  attrs: {
                    show: _vm.showHistoryDialog,
                    item: _vm.selectedItem,
                  },
                  on: {
                    "update:show": function ($event) {
                      _vm.showHistoryDialog = $event
                    },
                  },
                }),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
            _c("emc-modal-form", {
              attrs: {
                title: "Informações",
                icon: "mdi-contacts",
                show: _vm.showInfoForm,
              },
              on: {
                "update:show": function ($event) {
                  _vm.showInfoForm = $event
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "form",
                  fn: function () {
                    return [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.infoForm) },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c("sys-occurrence-sheet-teacher-view-register", {
              attrs: { model: _vm.modelItem, show: _vm.showFormRegisters },
              on: {
                "update:show": function ($event) {
                  _vm.showFormRegisters = $event
                },
              },
            }),
            _c("sys-occurrence-sheet-teacher-item-register", {
              attrs: {
                model: _vm.modelItem,
                show: _vm.showFormItems,
                isBlockedByTerms: _vm.isBlockedByTerms,
                showAddItem: "",
                showEditMark: "",
              },
              on: {
                onCompleted: function ($event) {
                  return _vm.getData()
                },
                "update:show": function ($event) {
                  _vm.showFormItems = $event
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }